import { BaseModel, deepClone } from 'paliari-js-utils'

const attributes = {
  id: null,
  cadastro: (obj = null) => (obj ? deepClone(obj) : null),
  cadastro_id: null,
  descricao: null,
  vistoria_em: null,
}

class DocLocal extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default DocLocal
